"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.thunkErrorHandler = void 0;
var _react = _interopRequireDefault(require("react"));
var _toolkit = require("@reduxjs/toolkit");
var _reactToastify = require("react-toastify");
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var thunkErrorHandler = function thunkErrorHandler() {
  return function (next) {
    return function (action) {
      var _action$payload;
      var withoutNotification = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.withoutNotification;
      if ((0, _toolkit.isAsyncThunkAction)(action) && (0, _toolkit.isRejected)(action) && !withoutNotification) {
        var message = (0, _toolkit.isRejectedWithValue)(action) ? action.payload.message : action.error.message;
        (0, _reactToastify.toast)( /*#__PURE__*/_react.default.createElement(_components.Notification, {
          content: message,
          type: "danger",
          title: "Error"
        }));
      }
      next(action);
    };
  };
};
exports.thunkErrorHandler = thunkErrorHandler;